export function getFullName(contact) {
  return `${contact.title} ${contact.first_name} ${contact.middle_name} ${contact.surname}`;
}
